<div class="col-lg-12 col-sm-12 col-xs-12" *ngIf="ticketForms.length > 0">
  <div class="checkout-title">
    <h3>Ticket Information</h3>
    <p class="ticket-info-text">Please provide name and email for each ticket</p>
  </div>
  <div class="ticket-forms-container" [formGroup]="captureForm">
    <div formArrayName="ticketForms">
      <div class="ticket-form" *ngFor="let ticketForm of ticketForms.controls; let i = index">
        <div [formGroupName]="i" class="ticket-form-content">
          <h4 class="ticket-title">{{ ticketForm.get('productTitle').value }} - Ticket #{{ ticketForm.get('ticketIndex').value + 1 }}</h4>
          <div class="row">
            <div class="form-group col-md-6 col-sm-12 col-xs-12">
              <label for="fullName-{{i}}">Full Name <span class="required-asterisk">*</span></label>
              <input 
                type="text" a
                id="fullName-{{i}}" 
                class="form-control" 
                [ngClass]="{'is-invalid': isFieldInvalid(i, 'fullName')}" 
                formControlName="fullName" 
                placeholder="Enter full name">
              <div *ngIf="isFieldInvalid(i, 'fullName')" class="error-message">
                <div *ngIf="ticketForm.get('fullName').errors?.required">Full name is required.</div>
              </div>
            </div>
            <div class="form-group col-md-6 col-sm-12 col-xs-12">
              <label for="email-{{i}}">Email Address <span class="required-asterisk">*</span></label>
              <input 
                type="email" 
                id="email-{{i}}" 
                class="form-control" 
                [ngClass]="{'is-invalid': isFieldInvalid(i, 'email')}" 
                formControlName="email" 
                placeholder="Enter email address">
              <div *ngIf="isFieldInvalid(i, 'email')" class="error-message">
                <div *ngIf="ticketForm.get('email').errors?.required">Email address is required.</div>
                <div *ngIf="ticketForm.get('email').errors?.email">Please enter a valid email address.</div>
              </div>
            </div>
            <div class="form-group col-md-6 col-sm-12 col-xs-12">
              <label for="industryType-{{i}}">Industry Type <span class="required-asterisk">*</span></label>
              <input 
                type="text" 
                id="industryType-{{i}}" 
                class="form-control" 
                [ngClass]="{'is-invalid': isFieldInvalid(i, 'industryType')}" 
                formControlName="industryType" 
                placeholder="Enter industry type">
              <div *ngIf="isFieldInvalid(i, 'industryType')" class="error-message">
                <div *ngIf="ticketForm.get('industryType').errors?.required">Industry type is required.</div>
                <div *ngIf="ticketForm.get('industryType').errors?.minlength">Industry type must be at least 4 characters.</div>
              </div>
            </div>
          </div>
          <hr class="ticket-divider" *ngIf="i < ticketForms.length - 1">
        </div>
      </div>
    </div>
  </div>
</div>
